import React, { useContext } from 'react';
import { WidgetRootContextType, WidgetRootProviderProps } from './types';

const WidgetRootContext = React.createContext<
  WidgetRootContextType | undefined
>(undefined);

export const WidgetRootProvider: React.FC<WidgetRootProviderProps> = ({
  children,
  rootElement,
}) => (
  <WidgetRootContext.Provider value={{ rootElement }}>
    {children}
  </WidgetRootContext.Provider>
);

export function useWidgetRoot() {
  const context = useContext(WidgetRootContext);

  if (context === undefined) {
    throw new Error('useWidgetRoot must be used within WidgteRootProvider');
  }

  return context;
}
